import { render, staticRenderFns } from "./LawOfficerConfirm.vue?vue&type=template&id=6bf53c37&"
import script from "./LawOfficerConfirm.vue?vue&type=script&lang=js&"
export * from "./LawOfficerConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports